import React, { Component } from 'react'
// Requests
import { appConfig } from '../../../../tools/AppConfig'
import axios from "axios"
import Waiting from './../../../../modules/waiting'
// VForm
import VForm from 'react-validation/build/form'
import VInput from 'react-validation/build/input'
import VButton from 'react-validation/build/button'
import validator from 'validator'
// Images
import Tabby from './../../../../../statics/img/tabby_pos/tabby.svg'
import Back from './../../../../../statics/img/tabby_pos/back.svg'
import TabbyPosStatus from './TabbyPosStatus'
import './TabbyPos.css'

// Validations
const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const numberV = (value) => {
    if(!validator.isNumeric(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid amount.</div>;
    }
};

class TabbyPos extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            step: 1,
            amount: "",
            trnx_id: "",
            tabby_pos_status: "",
            status_message: "",
            pos_data: "",
            //public
            waiting: false,
            error: false,
            error_message: "",
        }
    }
    componentDidMount = () => {
        //  handle current step
        let transaction_id = null;
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        transaction_id = urlParams.get('trx_id')
        if(transaction_id != null){
            this.setState({trnx_id: transaction_id}, () => {
                this.handleInquiryRequest()
            })
        }
    }

    // pay request
    handlePayRequest = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "identifier": "500000001",
                    "subtype": "TABBY_IN_STORE",
                    "email": "card.success@tabby.ai",
                    "amount_cents" : this.state.amount * 100,
                },
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({error: false, error_message: "", trnx_id: resp.data.transaction_id}, () => {
                    window.location.href = resp.data.redirecy_url;
                });
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({waiting: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
        e.preventDefault();
    }
    // inquiry request
    handleInquiryRequest = () =>{
        this.setState({step: 2, waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + "/api/acceptance/transactions/transaction_inquiry";
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // success
                if(resp.data.success == "true" && resp.data.pending == "false"){
                    this.setState({waiting: false, tabby_pos_status: "success", status_message: resp.data["data.message"], pos_data: resp.data});
                // pending
                }else if(resp.data.success == "false" && resp.data.pending == "true"){
                    this.setState({waiting: false, tabby_pos_status: "pending", status_message: resp.data["data.message"], pos_data: resp.data});
                // fail
                }else if(resp.data.success == "false" && resp.data.pending == "false"){
                    this.setState({waiting: false, tabby_pos_status: "fail", status_message: resp.data["data.message"], pos_data: resp.data});
                }
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({waiting: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
    }
    // handle return back to POS
    handleReturnBack = () => {
        if(window.androidInterface){
            try{
                window.androidInterface.cancel_trnx()
            }catch (e){
                window.androidInterface.cancel_trnx()
            }
        }
    }

    renderStepOne = () => (
        <div className="tabby_pos_content">
            <VForm onSubmit={this.handlePayRequest}>
                <label>Enter Amount</label>
                <div className="tabby_pos_input">
                    <VInput 
                        type="text"
                        name="amount"
                        value={this.state.amount}
                        onChange={(e)=>this.setState({amount: e.target.value})}
                        validations={[required, numberV]}
                        placeholder= "00.0 EGP"
                    />
                </div>
                <VButton>Confirm Amount</VButton>
            </VForm>
            {this.state.error &&
                <div className="tabby_pos_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )
    

    render() {
        return (
            <div className="tabby_pos_container">
                <div className="tabby_pos_header">
                    {this.state.step == 1 && <img src={Back} className="back" onClick={()=>this.handleReturnBack()} />}
                    <img src={Tabby} />
                </div>
                {this.state.waiting ?
                    <div className="waiting_container">
                        <Waiting height='200px' />
                    </div>
                :
                    this.state.step == 1 ?
                        this.renderStepOne()
                    :
                        <TabbyPosStatus
                            tabby_pos_status={this.state.tabby_pos_status}
                            status_message={this.state.status_message}
                            pos_data={this.state.pos_data}
                            error={this.state.error}
                            error_message={this.state.error_message}
                        />
                }
            </div>
        )
    }
}
export default TabbyPos